<script lang="ts">
  export let size = 24;
</script>

<svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M13.2203 5.80003L10.2003 2.78003C9.56698 2.1467 8.69364 1.8067 7.80031 1.85337L4.46698 2.01337C3.13364 2.07337 2.07364 3.13337 2.00698 4.46003L1.84698 7.79337C1.80698 8.6867 2.14031 9.56003 2.77364 10.1934L5.79364 13.2134C7.03364 14.4534 9.04697 14.4534 10.2936 13.2134L13.2203 10.2867C14.467 9.05337 14.467 7.04003 13.2203 5.80003ZM6.33364 8.25337C5.27364 8.25337 4.41364 7.39337 4.41364 6.33337C4.41364 5.27337 5.27364 4.41337 6.33364 4.41337C7.39364 4.41337 8.25364 5.27337 8.25364 6.33337C8.25364 7.39337 7.39364 8.25337 6.33364 8.25337Z"
    class={$$props.class || "fill-current"}
  />
</svg>
